import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PRODUCT_EXTRA_ENRICHMENT_FIELDS = [{
  key: 'builderId'
}, {
  key: 'type'
}, {
  alias: 'hitUrl',
  key: 'url'
}, {
  alias: 'creativeTitle',
  key: 'title'
}, {
  alias: 'creativeText',
  key: 'description'
}];
export function getJsonFields(parsedDecodedParams) {
  var jsonFields = PRODUCT_EXTRA_ENRICHMENT_FIELDS.reduce(function (acc, el) {
    var value = parsedDecodedParams[el.key];
    if (value !== '' && value != null) {
      acc[el.alias || el.key] = value;
    }
    return acc;
  }, {});
  if (parsedDecodedParams.objectId) {
    jsonFields.dealType = parsedDecodedParams.dealType || 'sale';
    jsonFields.objectType = parsedDecodedParams.objectType || 'jk';
    jsonFields.objectId = parsedDecodedParams.objectId;
  } else if (
  /**
   * @deprecated Условие устаревшее, это адаптер, что бы в аналитику сразу нормальные данные отсылать,
   * а постановка что бы могла плавно переходить на новый формат
   */
  parsedDecodedParams.newBuildingId) {
    jsonFields.dealType = 'sale';
    jsonFields.objectType = 'jk';
    jsonFields.objectId = parsedDecodedParams.newBuildingId;
  }
  return jsonFields;
}

/** @deprecated Удалить при отказа от тизер событий */
var PRODUCT_EXTRA_ENRICHMENT_FIELDS__DEPRECATED = [{
  key: 'builderId'
}, {
  key: 'newbuildingId'
}, {
  key: 'type'
}, {
  key: 'builderName'
}, {
  alias: 'hitUrl',
  key: 'url'
}, {
  alias: 'creativeTitle',
  key: 'title'
}, {
  alias: 'creativeText',
  key: 'description'
}];

/** @deprecated Удалить при отказа от тизер событий */
export function getJsonFields__DEPRECATED(parsedDecodedParams) {
  return PRODUCT_EXTRA_ENRICHMENT_FIELDS__DEPRECATED.reduce(function (acc, el) {
    var value = parsedDecodedParams[el.key];
    if (value !== '' && value != null) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el.alias || el.key, value));
    }
    return acc;
  }, {});
}